import CheckPointEditor from './CheckPointEditor';

export default CheckPointEditor;
